import React, { Component } from "react";
import instance from "../../axios";
import Loader from "../../Layout/Loader";
import { getCompanyById } from "../../Helpers";
import {
  BayanatDeliveryNoteMui,
  mapDeliveryNoteToDoc,
  printMuiDoc,
  fetchAccountTermsSetting,
  resolveContractNumber,
} from "../../Components/Documents";

let selectedInvoice = false;
let serverTimeZoneName = "";

const resolveTimezoneFromQuery = (raw) => {
  try {
    return decodeURIComponent((raw || "").split("&")[0]) || "Asia/Riyadh";
  } catch (e) {
    return (raw || "").split("&")[0] || "Asia/Riyadh";
  }
};

class Invoice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      data1: {},
      name: "",
      loader: false,
      company: null,
      didAutoPrint: false,
    };
  }

  componentWillMount() {
    const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
    const queryString = window.location.search;

    var res = queryString.split("?&token=");
    let invoiceId = res[1].split("&leasing=");
    let sz = invoiceId[1].split("&timezone=");
    selectedInvoice = sz[0] === "true" ? "cash" : "invoices";
    serverTimeZoneName = resolveTimezoneFromQuery(sz[1]);

    const apiUrl =
      selectedInvoice === "cash"
        ? `/api/cashdeliverynotes/${invoiceId[0]}`
        : `/api/deliverynotes/${invoiceId[0]}`;

    this.setState(
      {
        loader: true,
      },
      () => {
        instance({
          method: "GET",
          url: apiUrl,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
          .then(async (response) => {
            let companyId = response?.companyId || userInfo?.companyId;
            if (companyId) {
              getCompanyById(companyId)
                .then((company) => {
                  this.setState({
                    company,
                  });
                })
                .catch((error) => {
                  console.error(error.message);
                });
            }
            // Single PO tax invoice needs bank/terms from account
            const params = new URLSearchParams(window.location.search);
            const isSinglePo = params.get("singlePo");
            let setting = response?.setting || null;
            if (isSinglePo) {
              const cn = resolveContractNumber(response);
              setting =
                (await fetchAccountTermsSetting(cn)) || setting;
            }
            this.setState({
              data1: { ...response, setting },
              loader: false,
            });
          })
          .catch((error) => {
            console.log("error ====", error);
            this.setState({ loader: false });
          });
      },
    );
  }

  componentDidUpdate() {
    this.maybeAutoPrint();
  }

  replaceAmpersands(obj) {
    if (!obj || typeof obj !== "object") return;
    for (const prop in obj) {
      if (typeof obj[prop] === "string") {
        obj[prop] = obj[prop].replace(/amp;/g, "");
      } else if (typeof obj[prop] === "object" && obj[prop] !== null) {
        this.replaceAmpersands(obj[prop]);
      }
    }
  }

  buildDoc() {
    const { data1, company } = this.state;
    if (!data1 || !Object.keys(data1).length) return null;

    const data = data1;
    this.replaceAmpersands(data);

    const params = new URLSearchParams(window.location.search);
    const inv = params.get("inv");
    const sDate = params.get("sDate");
    const singlePo = params.get("singlePo");

    // Other Customers DN (cashdeliverynotes) + normal DN: group by categoryName
    return mapDeliveryNoteToDoc(data, company, {
      timezone: serverTimeZoneName,
      singlePo: !!singlePo,
      inv,
      sDate,
    });
  }

  maybeAutoPrint() {
    const params = new URLSearchParams(window.location.search);
    const autoPrint = params.get("autoPrint");
    const { loader, data1, didAutoPrint } = this.state;

    if (
      loader ||
      !data1 ||
      !Object.keys(data1).length ||
      didAutoPrint ||
      !autoPrint
    ) {
      return;
    }

    // Wait until #doc is painted (and company optionally loaded)
    this.setState({ didAutoPrint: true }, () => {
      const doc = this.buildDoc();
      printMuiDoc({
        title: doc?.titleEn || "Delivery Note",
      }).then(() => {
        window.onafterprint = () => {
          try {
            window.close();
          } catch (e) {
            // ignore
          }
        };
      });
    });
  }

  render() {
    const { loader, data1 } = this.state;

    if (loader || !data1 || !Object.keys(data1).length) {
      return <Loader component="filter" />;
    }

    const doc = this.buildDoc();
    return <BayanatDeliveryNoteMui doc={doc} />;
  }
}

export default Invoice;
